import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import IndexRepository from '../Repositories/IndexRepository'


class IndexBloc {

    workUnitChannel = new Subject();
    empChannel = new Subject();
    exportChannel = new Subject();
    repository = new IndexRepository()

    constructor() {
        this.workUnitChannel.next({status: apiResponse.INITIAL})
        this.empChannel.next({status: apiResponse.INITIAL})
        this.exportChannel.next({status: apiResponse.INITIAL})
    }

    fetchWorkUnit = async (query) => {
        try {
            this.workUnitChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchWorkUnit(query).then((result) => {
                this.workUnitChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.workUnitChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }

    fetchExport = async (query) => {
        try {
            this.exportChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchExport(query).then((result) => {
                this.exportChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.exportChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }
    fetchExport_lamakerja = async (query) => {
        try {
            this.exportChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchExport_lamakerja(query).then((result) => {
                this.exportChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.exportChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }
    fetchExport_tdkhadirperunitAlpha = async (query) => {
        try {
            this.exportChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchExport_tdkhadirperunitAlpha(query).then((result) => {
                this.exportChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.exportChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }
    fetchAkumulasiperunit = async (query) => {
        try {
            this.exportChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchAkumulasiperunit(query).then((result) => {
                this.exportChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.exportChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }
    fetchIzinExport = async (query) => {
        try {
            this.exportChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchIzinExport(query).then((result) => {
                this.exportChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.exportChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }
    fetchIzinExport2 = async (query) => {
        try {
            this.exportChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchIzinExport2(query).then((result) => {
                this.exportChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.exportChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }
    fetchIzinSTExport = async (query) => {
        try {
            this.exportChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchIzinSTExport(query).then((result) => {
                this.exportChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.exportChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }
    fetchKehadiranPerorangExport = async (query) => {
        try {
            this.exportChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchKehadiranPerorangExport(query).then((result) => {
                this.exportChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.exportChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }
    fetchAbsensiPerorangExport = async (query) => {
        try {
            this.exportChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchAbsensiPerorangExport(query).then((result) => {
                this.exportChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.exportChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }
    fetchKehadiranPerUnitExport = async (query) => {
        try {
            this.exportChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchKehadiranPerUnitExport(query).then((result) => {
                this.exportChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.exportChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }
    fetchAbsensiPerUnitExport = async (query) => {
        try {
            this.exportChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchAbsensiPerUnitExport(query).then((result) => {
                this.exportChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.exportChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }
    fetchEmployee = async (query) => {
        this.empChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchEmployee(query).then((result) => {
            this.empChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.empChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
}

export default IndexBloc